import { Channel, ChatRoom } from '@dinosband/bv-main-schema/dist/types'
import { BvDataCenterContext } from '../..'
import { DataCenter_StoreType } from '../abstract'
import { CHAT_ROOM_ADDED } from './const'

export class ChannelChatRooms extends DataCenter_StoreType<number, ChatRoom> {
  channel: Channel
  channelId: number

  constructor (channel: Channel, context: BvDataCenterContext) {
    super(context)
    this.channel = channel
    this.channelId = channel.id
  }

  async init () {
    this.initChatRooms()
  }

  publish () {
    const chatRooms = Object.values(this._pool)
    this.context.pubsub.publish(CHAT_ROOM_ADDED, {
      channelId: this.channelId,
      chatRooms,
    })
  }

  get chatRooms () {
    return this.values
  }

  private initChatRooms () {
    const chatRooms = this.channel.chatRoomMenus.flatMap((i) => i.chatRoom ?? [])
    chatRooms.forEach((i) => this.set(i.id, i))
  }

}
